import React from 'react';
export function PainSection() {
  return <section className="py-8 sm:py-12 px-4 bg-white" data-id="element-90">
      <div className="max-w-3xl mx-auto text-center" data-id="element-91">
        <h2 className="text-3xl sm:text-4xl font-serif font-bold text-brand-text-dark mb-6" data-id="element-92">
          Living With Hypothyroidism Is Hard Enough
        </h2>

        <div className="space-y-2 text-lg text-brand-text-muted mb-6" data-id="element-93">
          <p data-id="element-94">Feeling exhausted.</p>
          <p data-id="element-95">Having less energy than you'd like.</p>
          <p data-id="element-96">Not knowing what to cook.</p>
          <p data-id="element-97">
            Reading conflicting information about thyroid health and nutrition.
          </p>
          <p data-id="element-98">Trying diets that only last a few days.</p>
          <p data-id="element-99">And always ending up with the same question:</p>
        </div>

        <p className="text-2xl sm:text-3xl font-serif italic text-brand-forest mb-6" data-id="element-100">
          "What am I actually supposed to eat?"
        </p>

        <p className="text-lg text-brand-text-dark font-medium mb-2" data-id="element-101">
          Most women don't need another diet.
        </p>
        <p className="text-lg text-brand-text-dark font-medium" data-id="element-102">
          They need a simple system filled with delicious recipes they can
          actually enjoy.
        </p>
      </div>
    </section>;
}